export default "__VITE_ASSET__BtWsRiFr__"